import bg_banner from "../../assets/images/bg/bg-banner-1.jpg";
export const careerGoal = {
    description: "With Tempest, you build a relationship with a team of employment and recruitment professionals in your community with personal relationships with the businesses that are hiring. Whether you’re searching for new job opportunities or you’re transitioning into a new career path, our recruiters understand that there’s more to you than your resume.\n",
    title: "We want to define your career",
    btnText: "",
    subtitle: "",
    banner: bg_banner
}